import { XStateEvent } from 'common/models/xstate';
import {
  RemoteEventExecutingTx,
  RemoteEventNoStoredTx,
  RemoteEventNoWalletConnected,
  RemoteEventTxError,
  RemoteEventTxSuccess,
} from './txMachine';
import { Address } from 'viem';

export enum IchiSwapEvent {
  UPDATE_ACCOUNT_INFO = 'UPDATE_ACCOUNT_INFO',
  INPUT_CHANGE = 'INPUT_CHANGE',
  APPROVE = 'APPROVE',
  UPGRADE_ICHI = 'UPGRADE_ICHI',
  RESET_ALLOWANCE = 'RESET_ALLOWANCE',
}

export type EventInputChangeArgs = {
  amount: string;
};

export type EventUpdateAccountInfoArgs = {
  address: Address;
  chainId: number;
};

type EventApproveUpgradeIchi = XStateEvent<IchiSwapEvent.APPROVE>;
type EventUpgradeIchi = XStateEvent<IchiSwapEvent.UPGRADE_ICHI>;
type EventResetAllowance = XStateEvent<IchiSwapEvent.RESET_ALLOWANCE>;
export type EventUpdateAccountInfo = XStateEvent<
  IchiSwapEvent.UPDATE_ACCOUNT_INFO,
  EventUpdateAccountInfoArgs
>;
export type EventChangeAmount = XStateEvent<
  IchiSwapEvent.INPUT_CHANGE,
  EventInputChangeArgs
>;

export type IchiSwapEvents =
  | EventUpdateAccountInfo
  | EventUpgradeIchi
  | EventApproveUpgradeIchi
  | EventChangeAmount
  | EventResetAllowance
  // Remote Tx Events
  | RemoteEventExecutingTx
  | RemoteEventTxError
  | RemoteEventTxSuccess
  | RemoteEventNoWalletConnected
  | RemoteEventNoStoredTx;
